import AuthService from "./AuthService";
import { SystemService } from "./SystemService";

export class StatsService{
    systemService = null;
    authService = null;
    api = null;

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();

        this.api = this.systemService.getApiAccess();
    }

    getVolumesPerShelf(dateFrom, dateTo){
        let sessionId = this.authService.getSessionId();
        let config = this.authService.getConfig();
        let statsPromise = new Promise((resolve, reject) => {
            this.api.post(`stats/volumesPerShelf/${config.whCode}`, {dateFrom, dateTo}, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return statsPromise;
    }
    getVolumesPerDateAndShelf(dateFrom, dateTo){
        let sessionId = this.authService.getSessionId();
        let config = this.authService.getConfig();
        let statsPromise = new Promise((resolve, reject) => {
            this.api.post(`stats/averageWeightAndVolumePerDateAndShelf/${config.whCode}`, {dateFrom, dateTo}, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return statsPromise;
    }

    getAverageWeightAndVolumePerShelf(dateFrom, dateTo){
        let sessionId = this.authService.getSessionId();
        let config = this.authService.getConfig();
        let statsPromise = new Promise((resolve, reject) => {
            this.api.post(`stats/averageWeightAndVolumePerShelf/${config.whCode}`, {dateFrom, dateTo}, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return statsPromise;
    }

    getUnAssessedVolumes(){
        let sessionId = this.authService.getSessionId();
        let config = this.authService.getConfig();
        let statsPromise = new Promise((resolve, reject) => {
            this.api.get(`stats/unAssessedVolumes/${config.whCode}`, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return statsPromise;
    }
}